// 英文版
export default {
  home: 'Home',
  aboutUs: 'About Us',
  productsAndServices: 'Products & Services',
  projectCases: 'Project Cases',
  contactUs: '📩 Contact Us',
  contactUs2: 'Contact Us',
  scrollDown: 'Scroll Down',
  companyName: 'Ocean Harmony Trade Co., Ltd',
  companyIntro: 'Company Introduction',
  brandStory: 'Brand Story',
  developmentHistory: 'Development History',
  corporateCulture: 'Corporate Culture',
  qualificationsAndHonors: 'Qualifications & Honors',
  partners: 'Partners',
  customer: 'Customer',
  domesticNetwork: 'Domestic Network',
  overseasNetwork: 'Overseas Network',
  businessOutlets: 'Business Outlets',
  fullCategoryTransportService: 'Full-Category Transport Service',
  oneStopSupplyChainService: '＂One-Stop＂ Supply Chain Service',
  mainEngineeringMaterialsProducts: 'Main Engineering Materials Products',
  logisticsBusiness: 'Logistics Business',
  materialsBusiness: 'Materials Business',
  fullSupplyChainBusiness: 'FullSupplyChain Business',
  aboutOceanHarmony: 'About Ocean Harmony',
  historyAndEvolution: 'History & Evolution (2024 ~ Present)',
  companyHonors: 'Company Honors',
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  send: 'Send',
  weChatQRCode: 'WeChat QR Code',
  scanToFollowUs: 'Scan to Follow Us',
  contact: 'Feel free to send your inquiry!',
  mondayToFriday: 'Sunday to Thursday',
  leaveMessage: 'Leave a Message',
  subject: 'Subject',
  nickname: 'Nickname',
  companyTopName: "Zhongcheng Group",
  transportation: "Zhongcheng Transport",
  copyright: "All rights reserved",
  companyTopTitle: "ZCTS SHENZHEN CO., LTD.",
  projectDetail: 'Project Detail',

  enterYourName: 'Please enter your nickname',
  enterYourPhone: 'Please enter your phone',
  enterYourEmail: 'Please enter your email',
  enterSubject: 'Please enter the subject',
  enterMessageContent: 'Please enter the message content',
  enterValidEmail: 'Please enter a valid email address',
  messageContentAtLeast10: 'Message content must be at least 10 characters',
  nameLengthBetween2And30: 'Name length must be between 2 and 30 characters',
  formSubmitSuccess: 'Submission successful! Thank you for your message.',
  completeFormBeforeSubmitting: 'Please complete the form before submitting',
  mainTilte: 'Deeply cultivate the field of engineering projects, supplying the following main materials products based on the characteristics of engineering projects',
  ViewDetails: 'View Details',
  Loading: 'Loading...',
  companyCoverage: "Domestic <span class=\"map-top\">&nbsp;13&nbsp;</span> companies cover major port cities along the national route",
  businessOutletsTitle1: "Ocean Harmony has currently established <span class='w-map-top'> &nbsp;9&nbsp; </span> directly managed overseas outlets",
  businessOutletsTitle2: "Over <span class='w-map-top'> &nbsp;14&nbsp; </span> years of deep presence in Africa and Southeast Asia",
  qayimatAlmuntajat: "Qayimat Almuntajat",
  LanguageMessage: "Language changed successfully!",
  WHATSAPP: 'WHATSAPP'
};